<template>
	<div class="">
		<select class="date-select" :value="value">
			<option
			  v-for="item in options"
			  :value="item.value"
			>{{ item.label }}
			</option>
		</select>
		<div class="chart" id="Devicedoorrecord"></div>
	</div>
</template>

<script>
import *as echarts from 'echarts'

export default {
	name: "DeviceDoorRecordEcharts",
	props:{
		deviceId: {
			validator: null // 禁用类型检查
		}
	},
	data() {
		return {
			// select 选择
			options: [{
				value: '1',
				label: '当日'
			}, {
				value: '2',
				label: '最近一周',
			}, {
				value: '3',
				label: '最近30天',
			}],
			value: '1',

			option: {
				title: {
					text: 'Step Line',
					left: 'center',
				},
				tooltip: {
					trigger: 'axis'
				},
				// legend: {
				// 	data: ['Step Start', 'Step Middle', 'Step End']
				// },
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				toolbox: {
					feature: {
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						name: 'Step Start',
						type: 'line',
						step: 'start',
						data: [0, 1, 0, 1, 1, 1, 0]
					},
				]
			}
		}
	},
	mounted() {
		this.drawLine();
	},
	methods: {
		drawLine() {
			const myChart = echarts.init(document.getElementById("Devicedoorrecord"));
			myChart.setOption(this.option);
		}
	}
}
</script>

<style scoped>
.chart {
	height: 400px;
	width: 100%;
}

.date-select {
	width: 100px;
	position: absolute;
	left: 5%;
	z-index: 10;
}
</style>